module.exports = __webpack_public_path__ + "img/phone.9b753d02.svg";